// extracted by mini-css-extract-plugin
export var bubble = "_3w-0";
export var container = "_3w-3";
export var contrastBorder = "_3w-4";
export var greyOut = "_3w-2";
export var initialsWrapper = "_3w-1";
export var large = "_3w-9";
export var medium = "_3w-8";
export var mediumSmall = "_3w-7";
export var mediumSmallMedium = "_3w-c";
export var micro = "_3w-5";
export var small = "_3w-6";
export var tiny = "_3w-b";
export var xTiny = "_3w-a";